/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.pageViewModule', ['angular-bind-html-compile', 'focus-if', 'jquery', 'slickCarousel',
  'thatisuday.ng-image-gallery', 'vimeoEmbed', 'bulbApp.ajaxModule', 'bulbApp.authModule',
  'bulbApp.autoSaveModule', 'bulbApp.bitRateModule', 'bulbApp.browserModule', 'bulbApp.configModule',
  'bulbApp.contentEditorModule', 'bulbApp.contentSelectorModule', 'bulbApp.coverImageModule', 'bulbApp.errorModule',
  'bulbApp.filtersModule', 'bulbApp.imageEditorModule', 'bulbApp.openGraphModule', 'bulbApp.pageModule',
  'bulbApp.jwplayerModule', 'bulbApp.jplayerModule', 'bulbApp.permissionsModule', 'bulbApp.recommendModule',
  'bulbApp.shareModule', 'bulbApp.translateModule', 'bulbApp.iziToastModule', 'bulbApp.unitModule',
  'bulbApp.uploadModule', 'bulbApp.utilsModule'])

  /**
   * Constant for CKE status of page.
   * OLD: Page will be open with old editor.
   * PENDING_UPGRADE: Page CKE upgrade pending.
   * UPGRADED: Page has been migrated to cke.
   * FAILED_UPGRADE: Page content has not been converted into cke. Failed due to some error.
   */
  .constant('CKE_STATUS', {
    OLD: 'OLD',
    PENDING_UPGRADE: 'PENDING_UPGRADE',
    UPGRADED: 'UPGRADED',
    FAILED_UPGRADE: 'FAILED_UPGRADE',
  })
  // Add the constants to the root scope:
  .run(['$rootScope', 'CKE_STATUS', ($rootScope, CKE_STATUS) => {
    // eslint-disable-next-line no-param-reassign
    $rootScope.CKE_STATUS = CKE_STATUS;
  }]);
